import { VENUE_FILTER_GROUP_LABELS } from './constants';
import { SelectableItemsGroup } from '../SelectableAccordion/types';

export const buildVenueFilterMenuItems = (runtimeGeneratedOptions: string[]): SelectableItemsGroup[] => {
  const options: SelectableItemsGroup['options'] = runtimeGeneratedOptions.map(optionName => ({
    label: optionName,
    id: optionName,
    hide: false,
    disabled: false,
  }));

  return [
    {
      groupLabel: VENUE_FILTER_GROUP_LABELS.CITY,
      groupId: 'CITY',
      type: 'checkbox',
      options,
      hide: false,
    },
  ];
};
